module.exports = __webpack_public_path__ + "img/img-24.18c6d28f.png";